import { useState, useEffect, useRef } from "react";
import ProductHeader from "../../Components/ProductsPages/ProductHeader";
import ProductsHeroSection from "../../Components/ProductsPages/ProductsHeroSection";
import { keyfeatures } from "../../Data/ProductPages/Data";
import ProductFooter from "../../Components/ProductsPages/ProductFooter";
import { FeatureHover } from "../../Components/ProductsPages/FeatureHover";
import RequestDemo from "../../Components/ProductsPages/RequestDemo";
import QSleeveImage from "../../Images/videothumbnail.jpg";
import BackgroundGradient from '../../Images/BackgroundGradient.png'
import BackgroundGradientSmall from '../../Images/BackgroundGradientSmall.png'
import VideoComponent from "../../Components/VideoComponent";
import { KeyFeatures } from "../../Components/KeyFeatures";
import TitleContent from "../../Components/TitleContent";



export default function ECDL() {
  const requestDemoRef = useRef(null);
  const architectureRef = useRef(null);

  const [backgroundImage, setBackgroundImage] = useState(``);

  useEffect(() => {
    const updateBackgroundImage = () => {
      if (window.innerWidth < 640) {
        setBackgroundImage(`url(${BackgroundGradientSmall})`);
      } else {
        setBackgroundImage(`url(${BackgroundGradient})`);
      }
    };

    updateBackgroundImage();

    window.addEventListener('resize', updateBackgroundImage);

    return () => window.removeEventListener('resize', updateBackgroundImage);
  }, []);

  const scrollToRequestDemo = () => {
    requestDemoRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  const scrollToArchitecture = () => {
    architectureRef.current.scrollIntoView({ behavior: 'smooth' });
  };

  const keyFeatures = [
    "Temperature Controller ranging from 10 degree-80 degree Celsius with stability &lt;50 mK",

"Integrated piezo amplifier and lock-in module for advanced frequency locking",
"Customizable wavelengths from UV to IR (Wavelength: 350 nm-1600 nm)",
"Narrow linewidth: ~1 MHz or better",
"Typical output power: ~100 mW",
"Current Controller: 0-500 mA (customizable with a stability of~3 µA",
"Mode Hop free tuning range: ~20 GHz, (typically with current and Piezo synchronized scanning, good for covering the hyperfine lines in a typical atomic/ionic/molecular lines)",
"Piezo controller with a range of 0-100 Volts DC with ripples ~ 50 µV (RMS), external and internal scanning options",
"Provision of customized locking electronics based on the requirement, robust locking tested upto 15 hrs continuous.",
"Computer-interfaced full electronics control system with GUI",
"Versatile for quantum sensing, communication, computing, and spectroscopy",
"Academia-friendly design for teaching and Quantum Technology research labs",
"Dimension of the Laser controller 250mm x 190mm x 90mm",
"Dimension of the ECDL head 124 x 80 x 79 mm"]




  return (
    <div className="w-full  flex flex-col gap-0 items-center justify-center bg-primary7">
      <div
        className="w-full width flex flex-col gap-0 items-center justify-center bg-contain bg-repeat"
        style={{ backgroundImage: backgroundImage }}
      >
        <ProductHeader scrollToRequestDemo={scrollToRequestDemo} />
        <div className="w-full h-[25rem] ">
          <ProductsHeroSection
            title1="Engineered Precision for"
            title2="Future Quantum Technologies"
            content="High-performance external cavity diode lasers with precise frequency control, enabling next-generation experiments in atomic, molecular, and optical physics. "
            scrollToArchitecture={scrollToArchitecture}
          />
        </div>

        <div className="w-full bg-primary7 width md:px-10  flex flex-col items-center justify-center pb-10 gap-1">
          <div className="w-[90%] text-center md:text-left text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem] font-RobotoBold text-white leading-tight px-3 ">
            <span className="wordGradient">External Cavity Diode Laser</span>{" "}
            (ECDL)
          </div>

          <div className="w-[90%] h-full  grid grid-cols-1 xl:grid-cols-2  place-items-start p-3">
            <div className="w-full  flex flex-col items-center justify-center  gap-1">
              <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
                A Narrow Linewidth External Cavity Diode Laser (ECDL) is
                developed with a fully computer-interfaced electronic control
                system. The system incorporates an ultra-low-noise current
                controller (on the order of nA), a high-stability temperature
                controller (on the order of 10 mK), a piezoelectric amplifier,
                and an integrated lock-in module. This configuration enables
                precise frequency stabilization by locking to atomic, molecular,
                or ionic reference lines through spectroscopy, or alternatively
                to a reference cavity.
              </div>
              <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
                Our ECDLs offer broad customizable wavelength coverage across
                the UV-Visible-IR spectrum, tailored to diverse applications in
                atomic physics, ionic systems, and optical communications. They
                deliver narrow linewidths of ~500 kHz or better (as required for
                your experiment) and typical output powers of ~100 mW.
              </div>

              <img
                className="mt-3 w-[300px] h-[233px]  object-contain rounded-lg md:rounded-2xl"
                src={require("../../../src/Images/Boxes/ECDL1_BOX.png")}
              ></img>
              <p className="w-full lg:max-w-[600px] text-center text-xs italic text-white/70 lg:mt-2">
                Figure 1: External Cavity Diode Laser
              </p>
            </div>

            <div className="w-full sm:px-10  flex items-start justify-start">
              <KeyFeatures features={keyFeatures} />
            </div>
          </div>
          <div className="w-[90%] h-full flex flex-col justify-center items-center   p-3">
            <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
              Ideal for cutting-edge research and practical deployments, our
              ECDLs power quantum optics experiments, precision metrology, and
              more.
            </div>
            <div className="w-full text-white text-left font-RobotoRegular text-xs md:text-sm px-3">
              Designed with academia in mind, these lasers serve as the
              centrepiece of our Academia Boxes*—perfect for undergraduate and
              postgraduate teaching laboratories as well. They can also be used
              independently to suit specific experimental needs.
            </div>
          </div>
          <div className="w-[90%] width md:px-10  flex flex-col items-center justify-center  gap-1">
            {/* <div className="font-RobotoBold  wordGradient text-[1.5rem] md:text-[2rem] 2xl:text-[2.3rem]">
            KEY FEATURES
          </div> */}
            <TitleContent
              title="KEY FEATURES"
              content="At the core of quantum technologies, these lasers are essential building blocks"
            />
            <div className="max-w-5xl  mx-auto px-3 md:px-8">
              <FeatureHover items={keyfeatures.ECDL} />
            </div>
          </div>
        </div>

        {/* <VideoComponent
          image={QSleeveImage}
          video={"https://thequantum.ai/videos/QSleeveVideo.mp4"}
        /> */}
        <div
          className="w-full bg-primary7 width flex flex-col items-center justify-center gap-2 "
          ref={requestDemoRef}
        >
          <RequestDemo />
        </div>
        {/* <div className="w-full h-[33rem]">
            <IframeWithPoster
                src="https://www.youtube.com/embed/ldmpb0k5v7E?si=USYWzTZkxH2JxKxk"
                poster={QSleeveImage}
                allow="accelerometer; autoplay; controls; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
            />
        </div> */}
        <ProductFooter />
      </div>
    </div>
  );
}

